<template>
    <aside
        class="hidden flex-1 justify-center lg:flex lg:items-start pt-[115px] animated-gradient"
    >
        <div class="mx-auto w-full max-w-[487px] px-10">
            <div class="mb-[90px] flex justify-center">
                <div class="relative h-56 w-full max-w-md">
                    <img
                        :src="graphs"
                        alt="Dmarceye Complete Monitoring Tool Image"
                        title="Dmarceye Complete Monitoring Tool Image"
                        :class="['block mx-auto mb-12', `w-458px]`, `h-276px]`]"
                    />
                </div>
            </div>

            <h2
                class="font-inter text-center text-[21px] font-bold leading-[100%] tracking-tight"
            >
                A Complete DMARC Monitoring Tool
            </h2>

            <p
                class="mt-[19px] font-inter text-center text-[#000] font-[Inter] text-[12.25px] font-normal not-italic leading-[142%]"
            >
                DMARCEye transforms raw DMARC XML reports into clear, actionable
                insights, showing all email traffic and authentication results
                for your domain.
            </p>

            <ul class="mt-[19px] mx-auto w-fit space-y-4">
                <li class="flex items-center gap-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-[18px] w-[18px] shrink-0 text-[#00C951]"
                        aria-hidden="true"
                    >
                        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                        <path d="m9 11 3 3L22 4"></path>
                    </svg>

                    <span
                        class="text-[#000] font-[Inter] text-[12.25px] font-normal not-italic leading-[142%]"
                    >
                        14-day free trial, no credit card required
                    </span>
                </li>

                <li class="flex items-center gap-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-[18px] w-[18px] shrink-0 text-[#00C951]"
                        aria-hidden="true"
                    >
                        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                        <path d="m9 11 3 3L22 4"></path>
                    </svg>

                    <span
                        class="text-[#000] font-[Inter] text-[12.25px] font-normal not-italic leading-[142%]"
                    >
                        Instant alerts on suspicious activities
                    </span>
                </li>

                <li class="flex items-center gap-3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="3"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="h-[18px] w-[18px] shrink-0 text-[#00C951]"
                        aria-hidden="true"
                    >
                        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
                        <path d="m9 11 3 3L22 4"></path>
                    </svg>

                    <span
                        class="text-[#000] font-[Inter] text-[12.25px] font-normal not-italic leading-[142%]"
                    >
                        Easy setup in under 5 minutes
                    </span>
                </li>
            </ul>
        </div>
    </aside>
</template>

<script setup lang="ts">
const graphs = new URL(
    "/resources/js/assets/images/graphs.svg",
    import.meta.url,
).href;
</script>

<style scoped>
.animated-gradient {
    background-image: linear-gradient(154deg, #f8fafc 22.94%, #e3f3fd 83.19%);
    background-size: 320% 320%;
    background-position: 0% 50%;
    animation: gradient-pan 28s ease-in-out infinite;
}

@keyframes glow-drift {
    0% {
        background-position:
            0% 50%,
            20% 30%;
    }
    50% {
        background-position:
            100% 50%,
            80% 70%;
    }
    100% {
        background-position:
            0% 50%,
            20% 30%;
    }
}
</style>
